<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-simple-table>
      <template v-slot:default>
      <tbody>
        <tr v-for="errs in getIper" :key="errs.errs_nr">
          <td><v-chip :color=kleur()>{{errs.iper_seq}}</v-chip></td>
          <td>{{ errs.errstaal_oms }} </td>
        </tr>
      </tbody>
      </template>
    </v-simple-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      inpt_code: null,
      title: null,
      iper_type: null,
      getIper: {}
    }
  },
  methods: {
    open(title, inpt_code, iper_type) {
      this.dialog = true;
      this.title = title;
      this.inpt_code = inpt_code;
      this.iper_type = iper_type;
      this.$axios
        .post("ares/json/ares/task/inpt/getIper.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIper"
          },
          getIper: {
            inpt_code: this.inpt_code,
            iper_type: this.iper_type
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.getIper = res.data.getIper;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    kleur(){
      if(this.iper_type == "Error") return 'red'; else return 'orange';
    }
  }
}
</script>
